import { Button } from "@blueprintjs/core";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import styled from "styled-components";
import { mailingListSignup } from "../../../api";
import { AppToaster } from "../../../singletons";

const Form = styled.form`
  display: flex;
  padding-top: 12px;
  margin-bottom: 28px;
`;

const Input = styled.input`
  flex-grow: 1;
  padding: 12px;
  font-size: var(--global-font-size-xs);
  background: transparent;
  border: 1px solid var(--global-green);
  box-sizing: border-box;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin-right: 8px;
  color: var(--global-off-white);
  line-height: 8px;
  ::placeholder {
    color: var(--global-off-white);
  }
  caret-color: var(--global-green);
`;

interface SubmitButtonProps {
  visible: "true" | "false";
}

const SubmitButton = styled(Button)<SubmitButtonProps>`
  visibility: ${(props: SubmitButtonProps) =>
    props.visible === "true" ? "visible" : "hidden"};
  width: 75px;
  height: 40px;
  text-align: center;
  background-color: var(--global-purple) !important;
  color: var(--global-off-white) !important;
`;

const MailingListBox: React.FC<{}> = () => {
  const [emailValue, setEmailValue] = useState<string>("");
  const [submitted, setSubmitted] = useState<boolean>(false);

  return (
    <Form
      onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
          await mailingListSignup(emailValue);
        } catch (err: any) {
          AppToaster.show({
            message: `Error signing up for the mailing list: ${err.message}`,
            intent: "danger",
          });
          return;
        }
        AppToaster.show({
          message: `Thanks for signing up for the mailing list!`,
          intent: "success",
        });
        setSubmitted(true);
        setEmailValue("");
      }}
    >
      <Input
        type="email"
        placeholder={
          submitted ? "Thanks for signing up!" : "Enter your email here"
        }
        value={emailValue}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setEmailValue(event.target.value);
        }}
        name="email"
        disabled={submitted}
        required
        autoComplete="off"
      />
      <SubmitButton
        visible={submitted || emailValue.length > 0 ? "true" : "false"}
        type="submit"
        disabled={submitted}
      >
        {submitted ? <FontAwesomeIcon icon={faCheck} /> : "I’m in!"}
      </SubmitButton>
    </Form>
  );
};
export default MailingListBox;
